import { useEffect } from 'react'

import { saveExperienceRecentSearch } from './useExperienceRecentSearches'

function getExperienceRecentSearchItem(params: {
  destinationId?: string
  destinationName?: string
  experienceId?: string
  experienceName?: string
}): App.SearchItem | undefined {
  const {
    destinationId,
    destinationName,
    experienceId,
    experienceName,
  } = params

  if (destinationId && destinationName) {
    return {
      searchType: 'destination',
      value: destinationId.split(',')[0],
      format: {
        mainText: destinationName,
      },
    }
  }

  if (experienceId && experienceName) {
    return {
      searchType: 'experience',
      value: experienceId,
      format: {
        mainText: experienceName,
      },
    }
  }

  return undefined
}

function useAddExperienceRecentSearch(queryParams: URLSearchParams, naturalLanguageSearchEnabled = false) {
  const destinationId = queryParams.get('destinationId') ?? undefined
  const destinationName = queryParams.get('destinationName') ?? undefined
  const experienceId = queryParams.get('experienceId') ?? undefined
  const experienceName = queryParams.get('experienceName') ?? undefined
  const checkIn = queryParams.get('checkIn') ?? undefined
  const checkOut = queryParams.get('checkOut') ?? undefined
  const categories = queryParams.get('categories') ?? undefined
  const vertical = queryParams.get('vertical') ?? undefined
  const isNaturalLanguageSearch = naturalLanguageSearchEnabled && !!queryParams.get('query') && !!queryParams.get('typeaheadId')

  useEffect(() => {
    if (isNaturalLanguageSearch) return
    const recentSearchItem = getExperienceRecentSearchItem({
      destinationId,
      destinationName,
      experienceId,
      experienceName,
    })
    if (!recentSearchItem) return

    const dates = {
      checkIn,
      checkOut,
      isAnytime: !(checkIn || checkOut),
    }

    const parsedCategories = categories
      ?.split(',')
      .map(Number)
      .filter(Number.isFinite)

    saveExperienceRecentSearch(recentSearchItem, dates, [], parsedCategories, vertical)
  }, [destinationId, destinationName, experienceId, experienceName, checkIn, checkOut, categories, vertical, isNaturalLanguageSearch])
}

export default useAddExperienceRecentSearch
